// extracted by mini-css-extract-plugin
export default {"rewardsSubContainer":"RewardsLoader_rewardsSubContainer__bQ05P","contentWidth":"RewardsLoader_contentWidth__wmpND"};